/* eslint-disable react/no-unused-prop-types,no-console,
react/no-danger,react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import ContentLoader from 'react-content-loader';
import { withTranslation } from 'react-i18next';
// material-ui/ core components
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import FilterIco from '@material-ui/icons/FilterList';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import Paginator from 'components/common/Paginator';
import { TableLoader } from 'components/common/TableLoader';
import Moment from 'react-moment';
import { defaultFilters } from 'components/Credit/List';
import { formatRoute } from 'react-router-named-routes';
import { USER } from 'routes/paths';
import { creditTypes } from 'config';
import WithPermission, {
  checkPermissions,
} from 'components/User/WithPermission';
import authContext from 'helpers/authContext';
import Filter from './Filter';

/**
 * @description - Credit Transaction presentational component
 * @augments React.Component
 */
class CreditTransactionList extends React.Component {
  static contextType = authContext;

  constructor(props) {
    super(props);
    this.state = {
      showFilters: false,
    };
  }

  /**
   * @description
   * Description of ReactTable columns.
   *
   * @returns {Array} Table columns.
   */
  renderColumns = () => {
    const { classes, t } = this.props;

    const hasPermission = checkPermissions(this.context, [
      'list_user',
      'list_credittransaction',
    ]);

    return [
      hasPermission && {
        Header: (
          <div className={`${classes.headerField} ${classes.center}`}>
            {t('credit.list.headers.id')}
          </div>
        ),
        accessor: 'id',
        sortable: false,
        filterable: false,
        maxWidth: 50,
      },
      hasPermission && {
        Header: (
          <span className={classes.headerField}>
            {t('credit.list.headers.user')}
          </span>
        ),
        accessor: 'user',
        sortable: false,
        filterable: false,
      },
      {
        Header: (
          <div className={`${classes.headerField} ${classes.center}`}>
            {t('credit.list.headers.amount')}
          </div>
        ),
        accessor: 'amount',
        sortable: false,
        filterable: false,
      },
      {
        Header: (
          <span className={classes.headerField}>
            {t('credit.list.headers.date')}
          </span>
        ),
        accessor: 'date',
        sortable: false,
        filterable: false,
      },
      {
        Header: null,
        sortable: false,
        filterable: false,
        maxWidth: 20,
      },
    ].filter(Boolean);
  };

  /**
   * @description
   * Map the data from api to ReactTable rows.
   *
   * @param {Array} edges - All ads from api.
   * @returns {Array} Table rows.
   */
  renderRows = edges => {
    const { classes } = this.props;

    return edges.map(({ node }) => ({
      id: (
        <WithPermission allowPermissions={['list_credittransaction']}>
          <p
            data-testid={`credit-transaction-id-${node.id}`}
            className={classes.center}
          >
            {node.id}
          </p>
        </WithPermission>
      ),
      user: (
        <WithPermission allowPermissions={['list_credittransaction']}>
          <div data-cy="adUserInfo" className={classes.adUserContainer}>
            {node.user && (
              <a
                className={['read', classes.adBtns, classes.titleBtn].join(' ')}
                href={formatRoute(`${USER.DETAILS}#logs`, { id: node.user.id })}
                data-testid={`agency-${node.user.id}`}
              >
                {node.user.fullname}
                <p>
                  <b> {node.user.email} </b>
                </p>
              </a>
            )}
          </div>
        </WithPermission>
      ),
      amount: (
        <h4
          className={`${classes.center} ${
            node.type === creditTypes.INCREMENT
              ? classes.runningTag
              : classes.deletedTag
          }`}
        >
          {node.type === creditTypes.INCREMENT ? '+' : '-'}
          {node.amount}
        </h4>
      ),
      date: (
        <h4>
          <Moment date={node.createdOn} format="llll" fromNow />
        </h4>
      ),
    }));
  };

  /**
   * @description
   * Handle show collapsed/full filters.
   */
  handleShowFilters = () => {
    const { showFilters } = this.state;
    this.setState({ showFilters: !showFilters });
  };

  /**
   * @description
   * Render Filter, Paginator and ReactTable components.
   * @returns {*} Filter, Paginator and ReactTable components.
   */
  render() {
    const {
      t,
      classes,
      data,
      fullLoading,
      loading,
      onChangeNumberOfRows,
      onChangePage,
      numberOfRowsSelected,
      paginationDirection,
      appliedFilters,
      onFilter,
      onRestartFilters,
    } = this.props;

    const edges = loading ? [] : data.creditTransactions.edges;
    const rows = this.renderRows(edges);
    const columns = this.renderColumns();
    const { showFilters } = this.state;

    return (
      <>
        <GridContainer justify="space-between" alignItems="center">
          <GridItem>
            <h3 className={classes.title}>{t('credit.list.title')}</h3>
          </GridItem>
        </GridContainer>

        <div className={classes.contentContainer}>
          <GridContainer justify="space-between" alignItems="center">
            <GridItem>
              <Button
                color="info"
                round
                simple={
                  !showFilters &&
                  JSON.stringify(appliedFilters) ===
                    JSON.stringify(defaultFilters)
                }
                onClick={this.handleShowFilters}
              >
                <FilterIco />
                <span>
                  {JSON.stringify(appliedFilters) ===
                  JSON.stringify(defaultFilters)
                    ? t('credit.filters.filter')
                    : t('credit.filters.filtering')}
                </span>
              </Button>
            </GridItem>
            <GridItem>
              {!loading ? (
                <Paginator
                  pageInfo={data.creditTransactions.pageInfo}
                  changePage={onChangePage}
                  changeNumberOfRows={onChangeNumberOfRows}
                  numberOfRowsSelected={numberOfRowsSelected}
                  paginationDirection={paginationDirection}
                />
              ) : (
                <ContentLoader height={67} width={327} speed={2}>
                  <path
                    // eslint-disable-next-line max-len
                    d="M199,16 L304,16 C307.313708,16 310,18.6862915 310,22 L310,46 C310,49.3137085 307.313708,52 304,52 L199,52 C195.686292,52 193,49.3137085 193,46 L193,22 C193,18.6862915 195.686292,16 199,16 Z M25.9861352,27.0121317 L70.0138648,27.0121317 C74.4244855,27.0121317 78,30.5876462 78,34.9982669 C78,39.4088876 74.4244855,42.9844021 70.0138648,42.9844021 L25.9861352,42.9844021 C21.5755145,42.9844021 18,39.4088876 18,34.9982669 C18,30.5876462 21.5755145,27.0121317 25.9861352,27.0121317 Z M103.986135,27.0121317 L148.013865,27.0121317 C152.424485,27.0121317 156,30.5876462 156,34.9982669 C156,39.4088876 152.424485,42.9844021 148.013865,42.9844021 L103.986135,42.9844021 C99.5755145,42.9844021 96,39.4088876 96,34.9982669 C96,30.5876462 99.5755145,27.0121317 103.986135,27.0121317 Z"
                    fill="#D8D8D8"
                  />
                </ContentLoader>
              )}
            </GridItem>
          </GridContainer>

          <div
            style={{
              maxHeight: showFilters ? 900 : 0,
              overflow: 'hidden',
              transition: 'all .2s ease',
            }}
          >
            <Filter
              appliedFilters={appliedFilters}
              onShowFilters={this.handleShowFilters}
              onFilter={onFilter}
              onRestartFilters={onRestartFilters}
            />
          </div>

          <div
            style={{
              margin: '0 8px',
            }}
          >
            {fullLoading ? (
              <TableLoader />
            ) : (
              <ReactTable
                data={rows}
                filterable
                columns={columns}
                loading={fullLoading}
                pageSize={
                  edges.length < numberOfRowsSelected
                    ? edges.length
                    : numberOfRowsSelected
                }
                showPagination={false}
                className={['-striped', '-highlight', classes.tbl].join(' ')}
                noDataText={t('credit.list.no_data')}
                minRows={edges.length < 1 ? 8 : edges.length}
              />
            )}
          </div>
        </div>
      </>
    );
  }
}

/**
 * ExpiredAdList PropTypes
 * @param classes - prop styles received from withStyles
 * @param data - prop ads query's results
 * @param numberOfRowsSelected - prop current number of rows selected
 * @param loading - prop ads query or mutations status
 * @param t - prop from HOC with string translations
 * @callback onChangePage - prop pass to Paginator
 * @callback onChangeNumberOfRows - prop pass to Paginator
 * @param {object} appliedFilters - prop from HOC with query string of filters
 * @callback onFilter - function prop pass to Filter component
 * @callback onRestartFilters - function prop pass to Filter component
 * @callback onRefresh - callback to refresh page
 */

CreditTransactionList.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.shape({}).isRequired,
  numberOfRowsSelected: PropTypes.number.isRequired,
  paginationDirection: PropTypes.string,
  onChangePage: PropTypes.func.isRequired,
  onChangeNumberOfRows: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fullLoading: PropTypes.bool.isRequired,
  appliedFilters: PropTypes.shape({}).isRequired,
  onFilter: PropTypes.func.isRequired,
  onRestartFilters: PropTypes.func.isRequired,
};

CreditTransactionList.defaultProps = {
  paginationDirection: 'NEXT',
};

// to fix: The withStyles HOC set contextTypes to a children component
// and it have problem with contextType assigned to PermissionList component
// This is a small hack, with intermediary Component to resolved it temporally
const WrapperCreditTransaction = props => <CreditTransactionList {...props} />;

export default withTranslation()(
  withStyles(extendedTablesStyle)(WrapperCreditTransaction),
);
